<div class="backtest-detail-container padding backtest-card">
  <div class="mat-display-1 font-bold flex-centered-container-vr padding-left text-primary-contrast">
    Create New Strategy - Review 
  </div>


  <mat-card class="ut-pro-elevated-card form-card">
    <div class="confirmation-wrapper">
      <div class="header no-margin">
        <h4 class="placeholder-text">
          Here's a quick summary of your new strategy workflow
        </h4>
      </div>

      <ul class="confirmation-point-list">
        <div class="check-list content-wrapper padding">
          <div class="list-item border-bot-light">
            <div class="list-icon">
              <img src="/assets/icons/trade.png" alt="">
            </div>

            <div class="text margin-hr pad-8-hr">
              <li> With this algo, you can trade on </li>

              <div class="symbols margin-8-vr pad-8-top">
                <mat-chip-list>

                  <mat-chip *ngFor="let symbol of addedSymbols;let idx = index;"
                    [class.chip-positive]="quotes[idx]!= null && quotes[idx].isTickUp"
                    [class.chip-negative]="quotes[idx]!= null && quotes[idx].isTickDown"
                    class="flex-centered-container">
                    <!-- {{ symbol.market_id }} -->
                    <div class="label pad-8">{{ symbol.scrip_name }}</div>
                    <!-- TODO: Check symbol precision -->
                    <div *ngIf="quotes[idx]" class="pad-8 ltp">{{ quotes[idx].LTP | precision:DEFAULT_PRECISION }}</div>
                  </mat-chip>
                </mat-chip-list>
              </div>
            </div>
          </div>

          <div class="list-item border-bot-light">
            <div class="list-icon">
              <img src="/assets/icons/cycle.png" alt="">
            </div>

            <div class="text margin-hr pad-8">
              <li *ngIf="strategy.isLot"> The algo will execute <span
                  class="text-accent">{{ strategy?.valueConvertedLot[0] | localeConverter: 0 }}
                  Lot(s)</span>
                of each instrument per cycle, and total <span class="text-accent">{{ strategy?.algoCycles}}</span>
                cycle(s)
                will be executed sequentially.
              </li>

              <li *ngIf="!strategy.isLot"> The algo will execute for <span class="text-accent">{{CURRENCY_LABEL}}
                  {{ strategy?.orderQty | localeConverter }}</span> of each instrument per cycle
                , and total <span class="text-accent">{{ strategy?.algoCycles}}</span> cycle(s) will be executed
                sequentially.
              </li>
            </div>
          </div>

          <div class="list-item border-bot-light">
            <div class="list-icon">
              <img src="/assets/icons/logic.png" alt="">
            </div>

            <div class="text spacer margin-hr pad-8">
              <li> Your algo will take positions based on the following logic. </li>

              <div class="symbols full-width margin-top" *ngIf="strategy">

                <div class="ut-pro-indicator-condition-string">
                  <div class="entry-condition-string condition-string no-margin">
                    <div class="condition-badge entry-badge margin-sm">
                      Entry
                    </div>

                    <div class="indicator-conditions color" [innerHTML]="strategy.entryIndicatorString"></div>
                  </div>

                  <div class="exit-condition-string condition-string no-margin">
                    <div class="condition-badge exit-badge margin-sm">
                      Exit
                    </div>

                    <div class="indicator-conditions color" [innerHTML]="strategy.exitIndicatorString"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="list-item border-bot-light">
            <div class="list-icon">
              <img src="/assets/icons/repair.png" alt="">
            </div>

            <div class="text margin-hr pad-8">
              <li class="pad-8-vr">
                You are trading on <span class="text-accent">{{ strategy?.productType }}</span> product and using
                <span class="text-accent">{{ strategy?.candleSize }}</span>
                candles for technical analysis.
              </li>

              <ng-container *ngIf="strategy?.strategyMode === StrategyFormBuildMode.WIZARD">
                <!-- RA-1402: uncomment when After hours security feature is implemented -->
                <!-- <li *ngIf="strategy?.strategyMode === StrategyFormBuildMode.WIZARD">Position repair is <span
                    class="text-accent pad-8-vr">OFF</span> </li> -->

                <li class="pad-8-vr">
                  <!-- After hours security is
                  <span class="text-accent">{{ strategy?.enablePositionProtection ? 'ON': 'OFF' }}</span>. -->

                  All open positions associated with this algo will be squared off at market price
                  at <span class="text-accent">{{ strategy?.positionExitTime | date:'shortTime' }}</span>
                  and re-initiated at market price at
                  <span class="text-accent">{{ strategy?.positionRetakeTime | date:'shortTime' }}</span>
                  on the next trading day
                </li>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- Only On Broker For Initial Phases
        <div class="broker-selection">
          <div class="header pad-8 text-center no-margin">
            <h1>Order Execution</h1>
            <h3>Select your preferred mode and broker for order execution.
              <span class="text-accent cursor-pointer" (click)="openBrokerModal()">
                Manage Broker
              </span>
            </h3>
            <mat-divider></mat-divider>

            <div class="check-list">
            </div>
          </div>

          <form class="padding" [formGroup]="modeOfExecutionMode">
            <div class="select-container flex-centered-container-vr margin-8-hr">
              <div class="label margin-right">
                <strong>Deploy On</strong>
              </div>

              <mat-form-field appearance="outline" class="condensed-select-field margin-left deploy-select-field"
                color="accent">
                <mat-select formControlName="marketType">
                  <mat-option [value]="WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_LIVE">
                    Live Market
                  </mat-option>

                  <mat-option [value]="WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_PAPERTRADE">
                    Forward Test
                  </mat-option>

                  <mat-option [value]="WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_BACKTESTING">
                    Backtest
                  </mat-option>

                  <mat-option [value]="-1">
                    Save Only
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </form>
        </div> -->

        <div class="naming-algo">
          <div class="header text-center no-margin pad-8">
            <h1>Before You Deploy</h1>
            <mat-divider></mat-divider>
          </div>

          <form [formGroup]="strategyForm" class="padding">
            <div class="form-field-row padding-top">
              <mat-form-field color="accent" appearance="outline" floatLabel="always"
                class="ut-pro-mat-form-field label-field min-capital-field full-width">
                <label class="ut-label">Minimum Capital Required</label>

                <div class="ng-spin-box-wrapper">
                  <input matInput placeholder="Enter Minimum capital" formControlName="minimumCapital" type="number"
                  appNumberOnly   ngSpinBox [min]="0">
                </div>

                <mat-error *ngIf="strategyForm.get('minimumCapital').hasError('required')">
                  Minimum Capital is required
                </mat-error>

                <mat-error *ngIf="strategyForm.get('minimumCapital').hasError('min')">
                  Minimum value is 1
                </mat-error>

                <mat-error *ngIf="strategyForm.get('minimumCapital').hasError('max')">
                  Maximum value is {{ MAX_ABSOLUTE_VALUE }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-field-row flex-space-evenly">
              <mat-form-field color="accent" appearance="outline" floatLabel="always"
                class="ut-pro-mat-form-field label-field public-strategy-field full-width margin-right">
                <label class="ut-label">Public Strategy</label>

                <mat-select placeholder="Select Option" formControlName="public">
                  <mat-option [value]="true">Yes</mat-option>
                  <mat-option [value]="false">No</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field color="accent" appearance="outline" floatLabel="always"
                class="ut-pro-mat-form-field label-field fixed-fee-field full-width margin-hr">
                <label class="ut-label">Fixed Fee (INR)</label>

                <div class="ng-spin-box-wrapper">
                  <input matInput placeholder="Enter Fixed Fee" formControlName="monthlyFee" type="number"
                  appNumberOnly  ngSpinBox [min]="0">
                </div>

                <mat-error *ngIf="strategyForm.get('monthlyFee').hasError('required')">
                  Fixed Fee is required
                </mat-error>

                <mat-error *ngIf="strategyForm.get('monthlyFee').hasError('min')">
                  Minimum value is 0
                </mat-error>

                <mat-error *ngIf="strategyForm.get('monthlyFee').hasError('max')">
                  Maximum value is {{ MAX_ABSOLUTE_VALUE }}
                </mat-error>

              </mat-form-field>

              <mat-form-field color="accent" appearance="outline" floatLabel="always"
                class="ut-pro-mat-form-field label-field fee-schedule-field full-width margin-left">
                <label class="ut-label">Fee Schedule</label>

                <mat-select placeholder="Select Schedule" formControlName="feeSchedule">
                  <mat-option *ngFor="let schedule of FEE_SCHEDULES_STRINGS | unsortedKeyValue"
                    [value]="schedule.value">
                    {{ schedule.value }}
                  </mat-option>
                </mat-select>

                <mat-error *ngIf="strategyForm.get('feeSchedule').hasError('required')">
                  Fee Schedule is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-field-row flex-space-evenly">
              <mat-form-field color="accent" appearance="outline" floatLabel="always"
                class="ut-pro-mat-form-field label-field minimum-multiplier-field full-width margin-right">
                <label class="ut-label">Minimum Multiplier</label>

                <div class="ng-spin-box-wrapper">
                  <input matInput placeholder="Enter Minimum Multiplier" formControlName="minimumMultiplier" type="number"
                    appNumberOnly [decimal]="false" [errorStateMatcher]="errMatcher" ngSpinBox [min]="0">
                </div>

                <mat-error *ngIf="strategyForm.get('minimumMultiplier').hasError('required')">
                  Minimum Multiplier is required
                </mat-error>

                <mat-error *ngIf="strategyForm.get('minimumMultiplier').hasError('min')">
                  Minimum value is 1
                </mat-error>

                <mat-error *ngIf="strategyForm.get('minimumMultiplier').hasError('max')">
                  Maximum value is {{ MAX_ABSOLUTE_VALUE }}
                </mat-error>

                <mat-error *ngIf="strategyForm.hasError('compErr')">
                  Min multiplier should be less than Max multiplier
                </mat-error>

              </mat-form-field>

              <mat-form-field color="accent" appearance="outline" floatLabel="always"
                class="ut-pro-mat-form-field label-field maximum-multiplier-field full-width margin-hr">
                <label class="ut-label">Maximum Multiplier</label>

                <div class="ng-spin-box-wrapper">
                  <input matInput placeholder="Enter Maximum Multiplier" formControlName="maximumMultiplier" type="number"
                    appNumberOnly [decimal]="false" [errorStateMatcher]="errMatcher" ngSpinBox [min]="0">
                </div>

                <mat-error *ngIf="strategyForm.get('maximumMultiplier').hasError('required')">
                  Maximum Multiplier is required
                </mat-error>

                <mat-error *ngIf="strategyForm.get('maximumMultiplier').hasError('min')">
                  Minimum value is 1
                </mat-error>

                <mat-error *ngIf="strategyForm.get('maximumMultiplier').hasError('max')">
                  Maximum value is {{ MAX_ABSOLUTE_VALUE }}
                </mat-error>

                <mat-error *ngIf="!strategyForm.get('maximumMultiplier').errors &&
                            strategyForm.hasError('compErr')">
                  Max multiplier should be greater than Min multiplier
                </mat-error>
              </mat-form-field>

              <mat-form-field color="accent" appearance="outline" floatLabel="always"
                class="ut-pro-mat-form-field label-field fee-schedule-field full-width margin-left">
                <label class="ut-label">Variable Fee (%)</label>

                <div class="ng-spin-box-wrapper">
                  <input matInput placeholder="Enter Variable Fee" formControlName="variableFee" type="number"
                    appNumberOnly  ngSpinBox [min]="0">
                </div>


                <mat-error *ngIf="strategyForm.get('variableFee').hasError('required')">
                  Variable Fee is required
                </mat-error>

                <mat-error *ngIf="strategyForm.get('variableFee').hasError('min')">
                  Minimum value is 0
                </mat-error>

                <mat-error *ngIf="strategyForm.get('variableFee').hasError('max')">
                  Maximum value is {{ MAX_PERCENTAGE }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-title mat-title font-bold margin-24-top">
              Strategy Information
            </div>

            <div class="form-field-row">
              <mat-form-field color="accent" appearance="outline" floatLabel="always"
                class="ut-pro-mat-form-field label-field strategy-name-field full-width">
                <label class="ut-label">Strategy Name</label>

                <input matInput placeholder="Enter Strategy Name" formControlName="algoName">

                <mat-error *ngIf="strategyForm.get('algoName').hasError('required')">
                  Strategy Name is required
                </mat-error>
                <mat-error *ngIf="strategyForm.get('algoName').hasError('pattern')">
                  Enter a valid Strategy Name
                </mat-error>
                <mat-error *ngIf="strategyForm.get('algoName').errors?.maxlength" class="error-algo-name">
                  Algo name cannot exceed 40 characters
                </mat-error>
                <mat-error *ngIf="strategyForm.get('algoName').hasError('sameAlgoName')">
                  Cannot add two algos with same name.
                </mat-error>

              </mat-form-field>
            </div>


            <div class="form-field-row">
              <mat-form-field color="accent" appearance="outline" floatLabel="always"
                class="chip-input-field ut-pro-mat-form-field label-field strategy-name-field full-width">
                <label class="ut-label">Strategy Tags</label>

                <mat-chip-list #tagList aria-label="Tag selection" class="strategy-tags-input">
                  <mat-chip *ngFor="let tag of tags" (removed)="removeTag(tag)">
                    {{tag}}
                    <button matChipRemove>
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip>
                  <input placeholder="Press enter to Add a tag" [matChipInputFor]="tagList"
                    [maxlength]="50"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="addTag($event)"
                    formControlName="strategyTagInput">
                </mat-chip-list>
              </mat-form-field>
            </div>


            <!-- <div class="form-field-row">
              <angular-editor [config]="ANGULAR_EDITOR_CONFIG" formControlName="algoNotes" ngDefaultControl></angular-editor>
            </div> -->
          </form>
        </div>
      </ul>

      <div class="action-buttons text-right padding">
        <button mat-button color="accent" type="button" class="ut-pro-button margin-8-hr"
          (click)="edit()" *ngIf="showEdit">

          <mat-icon class="mat-18">arrow_back</mat-icon>

          <span class="font-inter-semibold font-16">
            Go back and edit strategy
          </span>
        </button>

        <div class="spacer"></div>

        <button mat-flat-button type="button" class="no-border bg-transparent normal-button"
          [disabled]="!strategyForm.valid" [class.fg-accent]="strategyForm.valid" (click)="deploy()">
          <span class="font-inter-semibold font-16">
            {{ isSaveOnly ? 'Done' : 'Deploy' }}
          </span>
        </button>

        <button mat-stroked-button color="accent" type="button" (click)="deploy(true)"
          [class.no-border]="!strategyForm.valid"
          class="deploy-button ut-pro-button normal-button submit-button margin-8-hr" [disabled]="!strategyForm.valid">
          <span class="font-inter-semibold font-16">
            Deploy
          </span>
        </button>

        <button mat-flat-button color="accent" type="button" (click)="runBackTest()"
          class="ut-pro-button gradient submit-button margin-8-left" [disabled]="!strategyForm.valid">
          <span class="font-inter-semibold font-16">
            Backtest
          </span>
        </button>
      </div>
    </div>
  </mat-card>
</div>
